import makeAllOperators from './makeAllOperators';
import Annotation from './Annotation';
import BinMesh from './BinMesh';
import Camera from './Camera';
import Environment from './Environment';
import Image from './Image';
import Light from './Light';
import Material from './Material';
import Player from './Player';
import PolyMesh from './PolyMesh';
import Properties from './Properties';
import Transform from './Transform';

const NoOp = { schema: {} };

const Bone = { Bone: NoOp };
const Null = { Null: NoOp };
const Pass = { Pass: NoOp };
const Mixer = { Action: NoOp, Mixer: NoOp };
const Renderer = { 'vray/create': NoOp, WebGLRenderer: NoOp };
const Timeline = { Timeline: NoOp };
const GeneralRenderer = { GeneralRenderer: NoOp };
const Viewport = { Viewport: NoOp };

const records = makeAllOperators({
  Annotation, BinMesh, Bone, Camera, Environment, GeneralRenderer, Light, Material,
  Mixer, Null, Pass, Player, PolyMesh, Properties,
  Renderer, Timeline, Transform, Image, Viewport,
}, { withNone: true });

export default records;



// WEBPACK FOOTER //
// ./src/operators/minimal.js